<template>
	<div
		class="b-spinner"
		:class="classes"
		:style="{
			'--color': color,
		}"
	></div>
</template>

<script>
export default {
	name: "BSpinner",
	props: {
		size: {
			type: String,
			default: "m",
		},
		color: {
			type: String,
			default: "primary",
		},
	},
	computed: {
		classes() {
			return [`b-spinner--${this.size}`, `b-spinner--${this.color}`];
		},
	},
};
</script>

<style lang="scss" scoped>
.b-spinner {
	width: var(--size);
	height: var(--size);
	border-radius: 50%;
	border: 3px solid rgba(0, 0, 0, 0.15);
	border-top-color: var(--border-top-color);
	animation: spin 1s ease-in-out infinite;

	&--m {
		--size: 40px;
		border-width: 3px;
	}

	&--xxs {
		--size: 10px;
		border-width: 2px;
	}

	&--primary {
		--border-top-color: var(--color-primary-600);
	}

	&--success {
		--border-top-color: var(--color-success-400);
	}
}

@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}
</style>
